"use client";

import "./PageBanner.scss";
import Link from "next/link";
import { IoIosArrowForward } from "react-icons/io";

const PageBanner = ({ title, page }) => {
  return (
    <section className="banner-section">
      <h1>{title}</h1>

      <div className="breadcrumbs">
        <Link href="/">Home</Link>
        <IoIosArrowForward />
        <span>{page || title}</span>
      </div>
    </section>
  );
};

export default PageBanner;
